




































import { Vue, Component, Prop } from 'vue-property-decorator'
import { BtnList } from '@/types/common/btn'
import { NewPersionMap } from '@/types/newPersion'
import { newPersionList, savePension } from '@/api/newPersion'

import { CommonMudule } from '@/store/modules/common'

import BaseInfo from '../../components/baseInfo/index.vue'
import FormItem from '@/components/formItem/index.vue'
import NewFooter from '../../components/newFooter'
@Component({
  components: { BaseInfo, FormItem, NewFooter },
})
export default class ReserveAnalysisPage extends Vue {
  @Prop() route!: string;
  @Prop() idx!: number;

  formItemList = [
    {
      label: '社保养老可提供:',
      value: 'currentInsuranceAmount',
      min: 0,
      maxs: 300000,
    },
    {
      label: '房租可提供:',
      value: 'currentRentAmount',
      tips: true,
      tipsContent: '每年通过房租可获得的收入',
      min: 0,
      maxs: 300000,
    },
    {
      label: '年金保险可提供:',
      value: 'currentAnnuityAmount',
      tips: true,
      tipsContent: '您平均每年从现有年金中可领取的金额',
      min: 0,
      maxs: 500000,
    },
    {
      label: '其他收入可提供:',
      value: 'currentOtherAmount',
      tips: true,
      tipsContent: '您所有其他可能领取的收入',
      min: 0,
      maxs: 500000,
    },
  ];

  form: NewPersionMap = {
    // retireAge: '', // 退休年龄
    // deathAge: '', // 养老年金领取至
    // totalIncome10k: '', // 家庭年收入（万元）
  };

  private setFormatTooltip (value: string) {
    return value + '元/年'
  }

  private async nextPage (item: BtnList) {
    if (item.btnType === 'ok') {
      const { form } = this
      if (!form.retireAge) {
        form.retireAge = 60
      }
      if (!form.deathAge) {
        form.deathAge = 84
      }
      await savePension({
        ...form,
        customerId: CommonMudule.customerId,
      })
    }
    this.$emit('on-edit-btn', item.btnType, this.idx)
  }

  async created () {
    const res = await newPersionList({ customerId: CommonMudule.customerId })
    if (res?.data) {
      this.form = res.data
    }
  }
}
